
import React from 'react';
import styles from './pdn-notification.module.scss';
import { FixedLinkParser } from '../fixed-link-parser/fixed-link-parser';

export interface PDNNotificationProps {
	onClose: () => void;
	policyLink: string;
	mode?: "hard" | "light" | "disable";
	text?: string;
}

const defaultText = "Мы обрабатываем данные посетителей и используем куки согласно [политике]";

export const PDNNotification: React.FC<PDNNotificationProps> = ({ onClose, policyLink, mode = "light", text }) => {
	if (mode == "disable") return <></>;
	return (<>
		{mode == "hard" && <div className={styles.blurOverlay} />}
		<div className={styles.noticeBox}>
			<div className={styles.text}>
				<FixedLinkParser text={text || defaultText} href={policyLink} linkStyle={styles.policyLink} />
			</div>
			<button className={styles.okButton} onClick={onClose}>
				OK
			</button>
		</div>
	</>)
};
